/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InputApplySignatures } from '../models';
// @ts-ignore
import type { ResponseApplySignatures } from '../models';
// @ts-ignore
import type { ServiceRequestDocumentToSign } from '../models';
/**
 * SignatureApi - axios parameter creator
 * @export
 */
export const SignatureApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get requested services
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allServiceRequestDocumentToSignByServiceId: async (serviceRequestId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceRequestId' is not null or undefined
            assertParamExists('allServiceRequestDocumentToSignByServiceId', 'serviceRequestId', serviceRequestId)
            const localVarPath = `/signature/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (serviceRequestId !== undefined) {
                localVarQueryParameter['serviceRequestId'] = serviceRequestId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply signatures
         * @param {InputApplySignatures} [inputApplySignatures] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applySignatures: async (inputApplySignatures?: InputApplySignatures, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/signature/apply-signature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputApplySignatures, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get requested document
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceRequestDocumentToSignById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getServiceRequestDocumentToSignById', 'id', id)
            const localVarPath = `/signature/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SignatureApi - functional programming interface
 * @export
 */
export const SignatureApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SignatureApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get requested services
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allServiceRequestDocumentToSignByServiceId(serviceRequestId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceRequestDocumentToSign>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allServiceRequestDocumentToSignByServiceId(serviceRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureApi.allServiceRequestDocumentToSignByServiceId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Apply signatures
         * @param {InputApplySignatures} [inputApplySignatures] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applySignatures(inputApplySignatures?: InputApplySignatures, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseApplySignatures>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applySignatures(inputApplySignatures, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureApi.applySignatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get requested document
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceRequestDocumentToSignById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRequestDocumentToSign>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceRequestDocumentToSignById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureApi.getServiceRequestDocumentToSignById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SignatureApi - factory interface
 * @export
 */
export const SignatureApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SignatureApiFp(configuration)
    return {
        /**
         * 
         * @summary Get requested services
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allServiceRequestDocumentToSignByServiceId(serviceRequestId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceRequestDocumentToSign>> {
            return localVarFp.allServiceRequestDocumentToSignByServiceId(serviceRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apply signatures
         * @param {InputApplySignatures} [inputApplySignatures] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applySignatures(inputApplySignatures?: InputApplySignatures, options?: RawAxiosRequestConfig): AxiosPromise<ResponseApplySignatures> {
            return localVarFp.applySignatures(inputApplySignatures, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get requested document
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceRequestDocumentToSignById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequestDocumentToSign> {
            return localVarFp.getServiceRequestDocumentToSignById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SignatureApi - interface
 * @export
 * @interface SignatureApi
 */
export interface SignatureApiInterface {
    /**
     * 
     * @summary Get requested services
     * @param {number} serviceRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignatureApiInterface
     */
    allServiceRequestDocumentToSignByServiceId(serviceRequestId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceRequestDocumentToSign>>;

    /**
     * 
     * @summary Apply signatures
     * @param {InputApplySignatures} [inputApplySignatures] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignatureApiInterface
     */
    applySignatures(inputApplySignatures?: InputApplySignatures, options?: RawAxiosRequestConfig): AxiosPromise<ResponseApplySignatures>;

    /**
     * 
     * @summary Get requested document
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignatureApiInterface
     */
    getServiceRequestDocumentToSignById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequestDocumentToSign>;

}

/**
 * SignatureApi - object-oriented interface
 * @export
 * @class SignatureApi
 * @extends {BaseAPI}
 */
export class SignatureApi extends BaseAPI implements SignatureApiInterface {
    /**
     * 
     * @summary Get requested services
     * @param {number} serviceRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignatureApi
     */
    public allServiceRequestDocumentToSignByServiceId(serviceRequestId: number, options?: RawAxiosRequestConfig) {
        return SignatureApiFp(this.configuration).allServiceRequestDocumentToSignByServiceId(serviceRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apply signatures
     * @param {InputApplySignatures} [inputApplySignatures] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignatureApi
     */
    public applySignatures(inputApplySignatures?: InputApplySignatures, options?: RawAxiosRequestConfig) {
        return SignatureApiFp(this.configuration).applySignatures(inputApplySignatures, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get requested document
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignatureApi
     */
    public getServiceRequestDocumentToSignById(id: number, options?: RawAxiosRequestConfig) {
        return SignatureApiFp(this.configuration).getServiceRequestDocumentToSignById(id, options).then((request) => request(this.axios, this.basePath));
    }
}

